import { Routes, Route, Navigate } from 'react-router-dom';
import { Home } from '@/pages/Home';
import { PaymentsPage } from '@/pages/payments/PaymentsPage';
import { UsersPage } from '@/pages/users/UsersPage';
import { AiiaConnectCallbackPage } from '@/pages/aiia/AiiaConnectCallbackPage';
import { HouseAccountAiiaConnectCallbackPage } from '@/pages/aiia/HouseAccountAiiaConnectCallbackPage';
import { ZenegyCallbackPage } from '@/pages/zenegy/ZenegyCallbackPage';
import { AiiaAuthorizeCallbackPage } from '@/pages/aiia/AiiaAuthorizeCallbackPage';
import { BankPage } from '@/pages/bank/BankPage';
import { InstaConfigPage } from '@/pages/instaconfig/InstaConfigPage';

import { SubscriptionPage } from '@/pages/subscription/SubscriptionPage';
import { CompanyAccountsPage } from '@/pages/companyAccounts/CompanyAccountsPage';
import { UserDetailsPage } from '@/pages/users/UserDetailsPage';
import React from 'react';

import { CompaniesPageV2 } from '@/pages/company/CompaniesPageV2';
import { ReportsDashboard } from '@/pages/reports/ReportsDashboard';
import { GlobalReportsDashboard } from '@/pages/reports/GlobalReportsDashboard';
import { CampaignActivationFunnelReport } from '@/pages/reports/CampaignActivationFunnelReport';
import { AllEmployeesPage } from '@/pages/employees/AllEmployees';
import TransactionsMonitoringPage from '@/pages/bank/TransactionsMonitoringPage';
import HouseAccountsPage from '@/pages/bank/HouseAccountsPage';
import { useDanLonCallback } from '@/lib/hooks/useDalonCallback';
import { TipsEmployeeListPage } from '@/pages/tips/TipsEmployeeListPage';
import { TipsAccountsPage } from '@/pages/tips/TipsAccountsPage';
import { InstaSignPage } from '@/pages/instasign/InstaSign';

const CompaniesPage = React.lazy(() =>
    import('../pages/company/CompaniesPage').then(({ CompaniesPage }) => ({
        default: CompaniesPage
    }))
);
const SettingsPage = React.lazy(() =>
    import('../pages/settings/SettingsPage').then(({ SettingsPage }) => ({
        default: SettingsPage
    }))
);

const ReconciliationPage = React.lazy(() =>
    import('../pages/reconciliation/ReconciliationPage').then(
        ({ ReconciliationPage }) => ({
            default: ReconciliationPage
        })
    )
);

const HistoryPage = React.lazy(() =>
    import('../pages/history/HistoryPage').then(({ HistoryPage }) => ({
        default: HistoryPage
    }))
);

export function Pages() {
    useDanLonCallback();

    return (
        <Routes>
            <Route path="payments/*" element={<PaymentsPage />} />
            <Route
                path="history/page/:pageNumber"
                element={
                    <React.Suspense fallback={<></>}>
                        <HistoryPage />
                    </React.Suspense>
                }
            />
            <Route
                path="settings/*"
                element={
                    <React.Suspense fallback={<></>}>
                        <SettingsPage />
                    </React.Suspense>
                }
            />
            <Route
                path="companies"
                element={
                    <React.Suspense fallback={<></>}>
                        <CompaniesPage />
                    </React.Suspense>
                }
            />
            <Route path="companies/v2" element={<CompaniesPageV2 />} />
            <Route path="companyAccounts" element={<CompanyAccountsPage />} />
            <Route path="instaconfig/*" element={<InstaConfigPage />} />
            <Route path="bank" element={<BankPage />} />
            {/* <Route path="payroll" element={<PayrollPage />} /> */}
            <Route
                path="reconciliation"
                element={
                    <React.Suspense fallback={<></>}>
                        <ReconciliationPage />
                    </React.Suspense>
                }
            />
            {/* <Route
                path="time-registrations"
                element={<TimeRegistrationPage />}
            /> */}
            <Route path="subscription" element={<SubscriptionPage />} />
            <Route path="users-list/page/:pageNumber" element={<UsersPage />} />
            <Route path="users/:userId/*" element={<UserDetailsPage />} />
            <Route
                path="payments/aiiaConnectCallback"
                element={<AiiaConnectCallbackPage />}
            />
            <Route
                path="payments/houseAccountAiiaConnectCallback"
                element={<HouseAccountAiiaConnectCallbackPage />}
            />
            <Route
                path="payments/aiiaAuthorizeCallback"
                element={<AiiaAuthorizeCallbackPage />}
            />
            <Route
                path="zenegy/connectCallback"
                element={<ZenegyCallbackPage />}
            />
            <Route path="reports/*" element={<ReportsDashboard />} />
            <Route
                path="global-reports/*"
                element={<GlobalReportsDashboard />}
            />
            <Route
                path="campaign-activation-funnel"
                element={<CampaignActivationFunnelReport />}
            />
            <Route path="/" element={<Home />} />
            <Route
                path="all-employees/page/:pageNumber"
                element={<AllEmployeesPage />}
            />
            <Route
                path="transaction-monitoring/page/:pageNumber"
                element={<TransactionsMonitoringPage />}
            />
            <Route path="house-accounts" element={<HouseAccountsPage />} />

            <Route path="tips-location" element={<TipsEmployeeListPage />} />
            <Route path="tips-accounts/*" element={<TipsAccountsPage />} />
            <Route
                path="insta-sign"
                element={<Navigate to="/insta-sign/page/0" replace />}
            />
            <Route
                path="insta-sign/page/:pageNumber"
                element={<InstaSignPage />}
            />
        </Routes>
    );
}
